class CustomiseInquiry extends HTMLElement {
  constructor() {
    super();
  }

  getProductTitle() {
    return this.dataset.productTitle;
  }

  connectedCallback() {
    const phoneNumber = "85266380204";
    const origin = "https://wa.me/";
    const prefixMessage = "I am interested in customising this product!";
    const productLink = window.location;
    const text = prefixMessage + '\n' + productLink;
    const encodedText = encodeURIComponent(text);

    const newLink = origin + phoneNumber + "?text=" + encodedText;

    this.link = this.querySelector('a');
    this.link.href = newLink;
  }

  disconnectedCallback() {
    // no clean up needed
  }
}

customElements.define("customise-inquiry", CustomiseInquiry);
